<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aDIEe8/images/cover.jpg?1684515200051" alt="This image is the cover for the book Basic Christianity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Basic Christianity
      </h1>
      <p class="bookDescription body article font2">
        <p>World-renowned preacher John Stott in this book clearly defines both the fundamental claims of Christianity and the proper out-workings of those basic beliefs in the daily lives of believers. Stott's <i>Basic Christianity</i> is a sound, sensible guide for anyone seeking an intellectually satisfying presentation of the Christian faith.<br/><br/> Named one of the Top 100 Books of the Millennium by <i>World</i> magazine and listed among <i>Christianity Today</i>'s Top 100 Books of the 20th Century, <i>Basic Christianity</i> has informed the faith of countless readers worldwide.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Stott
      </h2>
      
      <p class="authorDescription body article">John Stott (1921&ndash;2011) was rector emeritus of All Souls Church, Langham Place, London, and founder of the London Institute for Contemporary Christianity.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?140f7c84